export default "__VITE_ASSET__CXsM4B$r__"